export enum PortalTypeEnum{
    InternalPortal=1,
    CreditorCentralPortal=2
}